import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7c0e5fdb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "My" }
const _hoisted_2 = { class: "user" }
const _hoisted_3 = { class: "userInfo" }
const _hoisted_4 = { class: "detail" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("我的店铺")
const _hoisted_7 = { class: "tags" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("实名认证")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("企业认证")
const _hoisted_10 = { class: "location" }
const _hoisted_11 = { class: "red" }
const _hoisted_12 = { class: "today" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "曝光数据", -1))
const _hoisted_14 = { class: "todayStatistics" }
const _hoisted_15 = { class: "item" }
const _hoisted_16 = { class: "value" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "曝光率", -1))
const _hoisted_18 = { class: "value" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "访客数", -1))
const _hoisted_20 = { class: "value" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "电联客户数", -1))
const _hoisted_22 = { class: "gridContainer" }
const _hoisted_23 = { class: "buy" }
const _hoisted_24 = { class: "left" }
const _hoisted_25 = { class: "left" }
const _hoisted_26 = { class: "right" }
const _hoisted_27 = { class: "prospect" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "潜在客户/电联客户数", -1))
const _hoisted_29 = { class: "listItem" }
const _hoisted_30 = { class: "info" }
const _hoisted_31 = { class: "name" }
const _hoisted_32 = { class: "tips" }
const _hoisted_33 = { class: "time" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode("拨打电话")
const _hoisted_35 = { class: "actions" }
const _hoisted_36 = /*#__PURE__*/_createTextVNode("我知道了")
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title" }, "呼叫电话", -1))
const _hoisted_38 = { class: "telNum" }
const _hoisted_39 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VanImage = _resolveComponent("VanImage")!
  const _component_VanButton = _resolveComponent("VanButton")!
  const _component_VanTag = _resolveComponent("VanTag")!
  const _component_VanIcon = _resolveComponent("VanIcon")!
  const _component_VanGridItem = _resolveComponent("VanGridItem")!
  const _component_VanGrid = _resolveComponent("VanGrid")!
  const _component_VanList = _resolveComponent("VanList")!
  const _component_VanPopup = _resolveComponent("VanPopup")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_VanImage, {
        src: $setup.userInfo.avatarUrl,
        fit: "cover",
        width: "72",
        height: "72",
        round: ""
      }, null, 8, ["src"]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString($setup.userInfo.nickName), 1),
          _createVNode(_component_VanButton, {
            class: "tostore",
            size: "mini",
            block: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({name:"ThenStore",query: {id:$setup.userInfo.shopId}})))
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode($setup["VipTag"], {
            type: $setup.userInfo.vipRank,
            year: 2
          }, null, 8, ["type"]),
          _withDirectives(_createVNode(_component_VanTag, {
            size: "small",
            plain: "",
            color: "#079BFD"
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 512), [
            [_vShow, $setup.userInfo.hasIdCard]
          ]),
          _withDirectives(_createVNode(_component_VanTag, {
            size: "small",
            plain: "",
            color: "#6775D2"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }, 512), [
            [_vShow, $setup.userInfo.hasBusinessLicense]
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_10, [
          _createVNode(_component_VanIcon, {
            name: "location",
            size: "14",
            color: "#EF8700"
          }),
          _createTextVNode(" " + _toDisplayString($setup.userInfo.address), 1)
        ], 512), [
          [_vShow, $setup.userInfo.address]
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_VanIcon, {
            name: "phone",
            size: "14",
            color: "#EF8700"
          }),
          _createTextVNode(_toDisplayString($setup.userInfo.mobile), 1)
        ])
      ])
    ]),
    _createVNode(_component_VanImage, {
      class: "menberAd",
      src: require("@/assets/img/my/rechargeableMember.png"),
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({name:"OpenMembership"})))
    }, null, 8, ["src"]),
    _createElementVNode("div", _hoisted_12, [
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("div", _hoisted_16, _toDisplayString($setup.userInfo.totalExposure || '-'), 1),
          _hoisted_17
        ]),
        _createElementVNode("div", {
          class: "item",
          onClick: $setup.showProspect
        }, [
          _createElementVNode("div", _hoisted_18, _toDisplayString($setup.userInfo.totalFlows), 1),
          _hoisted_19
        ]),
        _createElementVNode("div", {
          class: "item",
          onClick: $setup.showProspect
        }, [
          _createElementVNode("div", _hoisted_20, _toDisplayString($setup.userInfo.totalMobileContant), 1),
          _hoisted_21
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_22, [
      _createVNode(_component_VanGrid, {
        border: false,
        "column-num": "3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_VanGridItem, {
            icon: "shop-o",
            text: "我的供应",
            onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.router.push({name:"MySupplyList"})))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_VanImage, {
                src: require("@/assets/img/my/mysupply.png"),
                width: "40",
                height: "40"
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_VanGridItem, {
            icon: "shop-o",
            text: "我的求购",
            onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.router.push({name:"MyWantToBuyList"})))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_VanImage, {
                src: require("@/assets/img/my/wantToBuy.png"),
                width: "40",
                height: "40"
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_VanGridItem, {
            icon: "shop-o",
            text: "我的报价",
            onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.router.push({name:"MyOfferPriceList",query:{tabindex:0}})))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_VanImage, {
                src: require("@/assets/img/my/offer.png"),
                width: "40",
                height: "40"
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_VanGridItem, {
            icon: "shop-o",
            text: "收到报价",
            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.router.push({name:"MyOfferPriceList",query:{tabindex:1}})))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_VanImage, {
                src: require("@/assets/img/my/quotesReceived.png"),
                width: "40",
                height: "40"
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_VanGridItem, {
            icon: "shop-o",
            text: "邀请赚红包",
            onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.jumpToWechatApp({url:"/packageA/pages/tuijian2/tuijian2"})))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_VanImage, {
                src: require("@/assets/img/my/inviteToEarnBonus.png"),
                width: "40",
                height: "40"
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_VanGridItem, {
            icon: "shop-o",
            text: "我的推广码",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.push({name:"ExtensionImages",query:{type:"poster",id:$setup.userInfo.shopId}})))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_VanImage, {
                src: require("@/assets/img/my/myPromotionCode.png"),
                width: "40",
                height: "40"
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_VanGridItem, {
            icon: "shop-o",
            text: "报价商机",
            onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.router.push({name:"BusinessOpportunity"})))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_VanImage, {
                src: require("@/assets/img/my/quoteOpportunities.png"),
                width: "40",
                height: "40"
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_VanGridItem, {
            icon: "shop-o",
            text: "签到",
            onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.router.push({name:"CheckIn"})))
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_VanImage, {
                src: require("@/assets/img/my/qiandao.png"),
                width: "40",
                height: "40"
              }, null, 8, ["src"])
            ]),
            _: 1
          }),
          _createVNode(_component_VanGridItem, {
            icon: "shop-o",
            text: "联系客服",
            onClick: $setup.toKefu
          }, {
            icon: _withCtx(() => [
              _createVNode(_component_VanImage, {
                src: require("@/assets/img/my/service.png"),
                width: "40",
                height: "40"
              }, null, 8, ["src"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_23, [
      _createElementVNode("span", _hoisted_24, [
        _createVNode(_component_VanImage, {
          src: require("@/assets/img/my/silver_s.png"),
          onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.router.push({name:"OpenMembership",query:{viprank:3}}))),
          width: "130",
          height: "80"
        }, null, 8, ["src"])
      ]),
      _createElementVNode("span", _hoisted_25, [
        _createVNode(_component_VanImage, {
          src: require("@/assets/img/my/gold_s.png"),
          onClick: _cache[11] || (_cache[11] = ($event: any) => ($setup.router.push({name:"OpenMembership",query:{viprank:6}}))),
          width: "130",
          height: "80"
        }, null, 8, ["src"])
      ]),
      _createElementVNode("span", _hoisted_26, [
        _createVNode(_component_VanImage, {
          src: require("@/assets/img/my/crown_s.png"),
          onClick: _cache[12] || (_cache[12] = ($event: any) => ($setup.router.push({name:"OpenMembership",query:{viprank:7}}))),
          width: "130",
          height: "80"
        }, null, 8, ["src"])
      ])
    ]),
    _createVNode(_component_VanPopup, {
      show: $setup.isShowPotential,
      "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => (($setup.isShowPotential) = $event)),
      position: "bottom",
      round: "",
      closeable: "",
      style: {"width":"100vw","height":"90%"}
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _createVNode(_component_VanList, {
            class: "list",
            listLoading: $setup.loading,
            "onUpdate:listLoading": _cache[13] || (_cache[13] = ($event: any) => (($setup.loading) = $event)),
            onLoad: $setup.loadMore,
            "immediate-check": false,
            finished: $setup.finished,
            "finished-text": "没有更多了"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.prospects, (item) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_29, [
                  _createVNode(_component_VanImage, {
                    src: item.visitorAvatarUrl,
                    width: "42px",
                    height: "42px",
                    round: ""
                  }, null, 8, ["src"]),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(item.visitorNickName), 1),
                    _createElementVNode("div", _hoisted_32, _toDisplayString(item.message), 1),
                    _createElementVNode("div", _hoisted_33, _toDisplayString($setup.moment(item.createTime).fromNow()), 1)
                  ]),
                  _createVNode(_component_VanButton, {
                    type: "success",
                    size: "mini",
                    color: "#F83B2D",
                    round: "",
                    onClick: ($event: any) => ($setup.call(item.visitorId))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_34
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]))
              }), 256))
            ]),
            _: 1
          }, 8, ["listLoading", "onLoad", "finished"]),
          _createElementVNode("div", _hoisted_35, [
            _createVNode(_component_VanButton, {
              type: "success",
              size: "small",
              color: "#FFCC32",
              round: "",
              onClick: _cache[14] || (_cache[14] = ($event: any) => ($setup.isShowPotential = false))
            }, {
              default: _withCtx(() => [
                _hoisted_36
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_VanPopup, {
      class: "callDialog",
      show: $setup.isShowTel,
      "onUpdate:show": _cache[16] || (_cache[16] = ($event: any) => (($setup.isShowTel) = $event))
    }, {
      default: _withCtx(() => [
        _hoisted_37,
        _createElementVNode("div", _hoisted_38, "是否拨打 " + _toDisplayString($setup.tel), 1),
        _createElementVNode("a", {
          class: "call",
          href: `tel:${$setup.tel}`
        }, "立即呼叫", 8, _hoisted_39)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode($setup["RestrictDialog"], {
      modelValue: $setup.restrictShow,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (($setup.restrictShow) = $event)),
      code: $setup.restrictCode,
      type: "single"
    }, null, 8, ["modelValue", "code"])
  ]))
}